import { render, staticRenderFns } from "./ProductActionButtons.vue?vue&type=template&id=c612286c&"
import script from "./ProductActionButtons.vue?vue&type=script&lang=js&"
export * from "./ProductActionButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports